import { render, staticRenderFns } from "./btCrudPesquisa.vue?vue&type=template&id=f6d7e758"
import script from "./btCrudPesquisa.vue?vue&type=script&lang=ts"
export * from "./btCrudPesquisa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports